let topUpIccid;

/**
* Adjust the product page to show the top-up UI
* */
function setupTopUpUI(setup_options) {
  document.getElementById('MainContent').classList.add('top_up');

  let productPageHeading = document.getElementById('product-text-overlay');
  if (productPageHeading) {
    productPageHeading.innerHTML = productTranslations.top_up_esim;
  }

  if (setup_options && setup_options.change_title != null && setup_options.change_title == "none") {
    let productPageBanner = document.getElementById('product_image_heading');
    if (productPageBanner) {
      productPageBanner.innerHTML = productTranslations.top_up_esim;
    }
  } else if (setup_options && setup_options.change_title != null && setup_options.change_title == "product_title") {
    /* Do nothing, title will come from product */
  } else if (setup_options && setup_options.change_title != null) {
    let productPageBanner = document.getElementById('product_image_heading');
    if (productPageBanner) {
      productPageBanner.innerHTML = setup_options.change_title;
    }
  }

  if (setup_options && setup_options.change_subheading != null && setup_options.change_subheading != "none") {
    let productPageSubheading = document.getElementById('product_image_text');
    if (productPageSubheading) {
      productPageSubheading.innerHTML = setup_options.change_subheading;
    }
  }

  let productTextItems = document.querySelectorAll('.product__info-container p');
  if (productTextItems && productTextItems.length > 0) {
    for (let i = 0; i < productTextItems.length; i++) {
      let textRegEx = new RegExp(productTranslations.travel_bundle, "ig")
      productTextItems[i].innerHTML = productTextItems[i].innerHTML.replaceAll(textRegEx, productTranslations.top_up_bundle);
    }
  }

  let topUpBannerText = document.getElementById('top_up_banner_text');
  if (topUpBannerText) {
    topUpBannerText.innerText = topUpBannerText.innerText + ' ' + topUpIccid;
  }

  let topUpHiddenTextSections = document.querySelectorAll('.text_with_title_container.display-for-new');

  if (topUpHiddenTextSections && topUpHiddenTextSections.length > 0) {
    for (let i = 0; i < topUpHiddenTextSections.length; i++) {
      topUpHiddenTextSections[i].remove();
    }
  }
}

/**
 * Remove the active iccid from sessionStorage, cancelling a top-up selection process
 */
function cancelTopUp() {
  sessionStorage.removeItem('topUpIccid');
  sessionStorage.removeItem('topUpCurrentBundle');
  location.reload();
}
